import { render, staticRenderFns } from "./MoviesSliderItem.vue?vue&type=template&id=795ccd3e&"
import script from "./MoviesSliderItem.vue?vue&type=script&lang=js&"
export * from "./MoviesSliderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports